<template>
  <div class="card">
    <div class="card-header">
      <h1 class="card-title" v-if="title">
        <i :class="icon" aria-hidden="true"></i>
        {{ title }}
      </h1>
      <div class="items" v-if="apiUrl">
        <span>{{ item.total }} {{ $t("items") }}</span>
        <span>{{ item.active }} {{ $t("activeItems") }}</span>
      </div>
    </div>
    <volcan-loading v-if="loading" :loading="loading" />
    <slot> </slot>
  </div>
</template>
<script>
export default {
  name: "volcan-card-layout",
  props: ["title", "icon", "apiUrl", "loading"],
  data: function () {
    return {
      item: {
        total: 0,
        active: 0,
      },
    };
  },
  computed: {},
  mounted() {
    this.getCount();
  },
  watch: {},
  methods: {
    getCount() {
      if (this.apiUrl) {
        window.axios.get(this.apiUrl).then((response) => {
          this.item.total = response.data.data.total;
          this.item.active = response.data.data.active;
        });
      }
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// components/AdminTools/card/card-layout.vue